const checkCalcPayAmount = {
    title: 'Внимание!',
    description:
        'При изменении проекта или суммы акта, произойдет <b>пересчёт итоговой суммы</b> исходя из новых указанных параметров',
    buttonText: 'Пересчитать',
} as const;

export default checkCalcPayAmount;
